<template>
    <div style="width: 100%; text-align: center">
        <img style="width: 100px"
             :src="getImage()">
        <div style="font-size: 15px; color: #c7c7c7; margin-top: 15px">{{message}}</div>
    </div>
</template>

<script>
    // import head from '../../mixins/head';

    export default {
        components: {
            // ICell
        },
        name: 'indicator',
        // mixins: [head],
        data() {
            return {};
        },
        props: {
            type: { // 1 网络  2 空列表  3 其他（如请求报错）
                type: Number,
                default: function () {
                    return 1;
                }
            },
            message: {
                type: String,
                default: function () {
                    return '网络异常';
                }
            }
        },
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            getImage() {
                switch (this.type) {
                    case 1:
                        return require('../../assets/img/indicator/common_indicator_wl.png');
                    case 2:
                        return require('../../assets/img/indicator/common_indicator_order.png');
                    case 3:
                        return require('../../assets/img/indicator/common_indicator_tz.png');
                    default:
                        return require('../../assets/img/indicator/common_indicator_wl.png');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
